import { render, staticRenderFns } from "./OwnerForm.vue?vue&type=template&id=0f0647ac&scoped=true&"
import script from "./OwnerForm.vue?vue&type=script&lang=ts&"
export * from "./OwnerForm.vue?vue&type=script&lang=ts&"
import style0 from "./owner-form.scss?vue&type=style&index=0&id=0f0647ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0647ac",
  null
  
)

export default component.exports